import React from 'react';
import useTranslator from '../hooks/translate';

/** Static interface text only; player names and chat messages stay unchanged. */
export function LocalizedText({ text }: { text: string }) {
  const t = useTranslator();
  return <>{t(text)}</>;
}
